module.exports = __webpack_public_path__ + "img/setting_8.575a58df.svg";